import { onViewLoad } from "jose_modern/on_view_load";
import { toggleAllergensVerifiedIngredientPath } from "routes";
import { AllergenInput, postAllergens } from "./common.js";

const VERIFIED_BUTTON_SELECTOR = "[data-allergens-verified]";
const VERIFIED_CLASS = "is-warning";
const UNVERIFIED_CLASS = "is-primary";

async function toggleAllergensVerified(ingredientId, allergens) {
  const url = toggleAllergensVerifiedIngredientPath(ingredientId);

  await postAllergens(url, allergens);
}

function isVerified(button) {
  return button.dataset.allergensVerified === "true";
}

function setVerified(button, verified) {
  button.dataset.allergensVerified = verified ? "true" : "false";
  button.classList.toggle(UNVERIFIED_CLASS, !verified);
  button.classList.toggle(VERIFIED_CLASS, verified);
  button.textContent = verified ? "Undo" : "Verify";
}

onViewLoad("ingredient_allergens#index", () => {
  document.querySelectorAll(".ingredient-allergens").forEach((container) => {
    const { ingredientId } = container.dataset;
    const input = new AllergenInput(container, () => {}, { warnUnsavedChanges: true });

    const row = container.closest("tr");
    const verifyButton = row.querySelector(VERIFIED_BUTTON_SELECTOR);

    verifyButton.addEventListener("click", async (e) => {
      const button = e.currentTarget;

      // collect() drops a subtype-less major, so Verify would mark the row done with nothing saved.
      if (!isVerified(button) && AllergenInput.showIncompleteWarning(container)) {
        return;
      }

      button.disabled = true;
      try {
        await toggleAllergensVerified(ingredientId, input.collectAllergens());
        setVerified(button, !isVerified(button));
      } finally {
        button.disabled = false;
      }
    });
  });
});
